/**
 *
 * Icons
 *
 */

import { faBuilding, faClipboard, faEnvelope } from '@fortawesome/free-regular-svg-icons';
import {
  faAddressBook,
  faAlignJustify,
  faBalanceScaleRight,
  faBars,
  faBell,
  faBolt,
  faBookOpen,
  faCalendarAlt,
  faCar,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faExclamationCircle,
  faCogs,
  faComment,
  faComments,
  faDatabase,
  faEuroSign,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileDownload,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faClone,
  faGasPump,
  faHammer,
  faHistory,
  faHome,
  faHourglass,
  faMapMarkerAlt,
  faPencilAlt,
  faPenSquare,
  faPercentage,
  faPlayCircle,
  faPlus,
  faQuestion,
  faScrewdriver,
  faSearch,
  faSmile,
  faSortDown,
  faSortUp,
  faSync,
  faSyncAlt,
  faTachometerAlt,
  faTextHeight,
  faTh,
  faThLarge,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTrophy,
  faGlobe,
  faTruckMoving,
  faUpload,
  faUser,
  faUserCircle,
  faUserTie,
  faTrash,
  faSort,
  faCloudUploadAlt,
  fa
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
  ArrowDown as ArrowDownIcon,
  ArrowLeft,
  ArrowRight,
  ArrowUp as ArrowUpIcon,
  Bookmark,
  Camera as CameraIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Clock as ClockIcon,
  CornerDownRight,
  HelpCircle,
  Image as ImageIcon,
  Power as PowerIcon,
  Settings as SettingsIcon,
  Users as FeatherUsersIcon,
} from 'react-feather';
import './style.scss';

import cn from 'classnames';

const TYPE_FEATHER = 'feather';
const TYPE_AWESOME = 'awesome';

/* eslint-disable react/prefer-stateless-function */
export class Icon extends React.PureComponent {
  getIcon() {
    return faCheck;
  }

  getClassNames() {}

  getProvider() {
    return TYPE_AWESOME;
  }

  renderIconComp() {
    if (this.getProvider() == TYPE_FEATHER) {
      let Comp = this.getIcon();
      return <Comp />;
    }
    return <FontAwesomeIcon icon={this.getIcon()} size="1x" />;
  }

  render() {
    return (
      <div
        onClick={(e) => {
          if (!this.props.onClick) return;
          e.stopPropagation();
          this.props.onClick(e);
        }}
        className={cn(`icon ${this.getClassNames()} icon-provider-${this.getProvider()}`, this.props.className)}
      >
        {' '}
        {this.renderIconComp()}
        {this.props.children}
      </div>
    );
  }
}

export class TextIcon extends Icon {
  getIcon() {
    return faTextHeight;
  }

  getClassNames() {
    return 'fa-text';
  }
}


export class Check extends Icon {
  getIcon() {
    return faCheck;
  }

  getClassNames() {
    return 'check';
  }
}
export class Email extends Icon {
  getIcon() {
    return faEnvelope;
  }

  getClassNames() {
    return 'email';
  }
}

export class CheckRound extends Icon {
  getIcon() {
    return faCheckCircle;
  }

  getClassNames() {
    return 'check round';
  }
}

export class Times extends Icon {
  getIcon() {
    return faTimes;
  }

  getClassNames() {
    return 'times';
  }
}

export class CircleTimes extends Icon {
  getIcon() {
    return faTimesCircle;
  }
  getClassNames() {
    return 'fa-sharp fa-solid fa-circle-xmark';
  }
}

export class Clock extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }
  getIcon() {
    return ClockIcon;
  }

  getClassNames() {
    return 'clock';
  }
}

export class Position extends Icon {
  getIcon() {
    return faMapMarkerAlt;
  }

  getClassNames() {
    return 'position';
  }
}

export class IsOpen extends Icon {
  getIcon() {
    return faChevronDown;
  }

  getClassNames() {
    return 'isOpen';
  }
}

export class IsClosed extends Icon {
  getIcon() {
    return faChevronUp;
  }

  getClassNames() {
    return 'isClosed';
  }
}

export class UpArrowHead extends Icon {
  getIcon() {
    return faChevronUp;
  }

  getClassNames() {
    return 'isOpen';
  }
}

export class UserIcon extends Icon {
  getIcon() {
    return faUser;
  }

  getClassNames() {
    return 'user';
  }
}

export class Question extends Icon {
  getIcon() {
    return faQuestion;
  }

  getClassNames() {
    return 'question';
  }
}

export class Right extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ArrowRight;
  }

  getClassNames() {
    return 'icon-right';
  }
}

export class Left extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ArrowLeft;
  }

  getClassNames() {
    return 'icon-left';
  }
}

export class Home extends Icon {
  getIcon() {
    return faHome;
  }

  getClassNames() {
    return 'icon-home';
  }
}

export class Building extends Icon {
  getIcon() {
    return faBuilding;
  }

  getClassNames() {
    return 'fa-buildings';
  }
}

export class Plus extends Icon {
  getIcon() {
    return faPlus;
  }

  getClassNames() {
    return 'icon-home';
  }
}

export class Euro extends Icon {
  getIcon() {
    return faEuroSign;
  }

  getClassNames() {
    return 'icon-euro';
  }
}

export class Comment extends Icon {
  getIcon() {
    return faComment;
  }

  getClassNames() {
    return 'icon-comment';
  }
}

export class Users extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return FeatherUsersIcon;
  }

  getClassNames() {
    return 'icon-users';
  }
}

export class Percentage extends Icon {
  getIcon() {
    return faPercentage;
  }

  getClassNames() {
    return 'icon-percentage';
  }
}
export class Tiles extends Icon {
  getIcon() {
    return faThLarge;
  }

  getClassNames() {
    return 'icon-tiles';
  }
}
export class Trophy extends Icon {
  getIcon() {
    return faTrophy;
  }

  getClassNames() {
    return 'icon-trophy';
  }
}

export class Alert extends Icon {
  getIcon() {
    return faExclamationTriangle;
  }

  getClassNames() {
    return 'icon-alert';
  }
}

export class AlertCircle extends Icon {
  getIcon() {
    return faExclamationCircle;
  }

  getClassNames() {
    return 'icon-alert';
  }
}

export class Calendar extends Icon {
  getIcon() {
    return faCalendarAlt;
  }

  getClassNames() {
    return 'icon-calendar';
  }
}

export class Mileage extends Icon {
  getIcon() {
    return faTachometerAlt;
  }

  getClassNames() {
    return 'icon-tachometer';
  }
}

export class TaxType extends Icon {
  getIcon() {
    return faUserTie;
  }

  getClassNames() {
    return 'icon-taxtype';
  }
}

export class CardView extends Icon {
  getIcon() {
    return faTh;
  }

  getClassNames() {
    return 'icon-cardview';
  }
}
export class TableView extends Icon {
  getIcon() {
    return faAlignJustify;
  }

  getClassNames() {
    return 'icon-tableview';
  }
}

export class Search extends Icon {
  getIcon() {
    return faSearch;
  }

  getClassNames() {
    return 'icon-search';
  }
}

export class Bars extends Icon {
  getIcon() {
    return faBars;
  }

  getClassNames() {
    return 'icon-bars';
  }
}

export class SignOut extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return PowerIcon;
  }

  getClassNames() {
    return 'icon-signout';
  }
}

export class Account extends Icon {
  getIcon() {
    return faUserCircle;
  }

  getClassNames() {
    return 'icon-account';
  }
}

export class Fuel extends Icon {
  getIcon() {
    return faGasPump;
  }

  getClassNames() {
    return 'icon-fuel';
  }
}

export class Car extends Icon {
  getIcon() {
    return faCar;
  }

  getClassNames() {
    return 'icon-car';
  }
}

export class Globe extends Icon {
  getIcon() {
    return faGlobe;
  }

  getClassNames() {
    return 'fa-globe';
  }
}

export class Truck extends Icon {
  getIcon() {
    return faTruckMoving;
  }

  getClassNames() {
    return 'fa-truck';
  }
}

export class CklockRotate extends Icon {
  getIcon() {
    return faHistory;
  }
  getClassNames() {
    return 'fa-clock-rotate-left';
  }
}

export class AddressBook extends Icon {
  getIcon() {
    return faAddressBook;
  }

  getClassNames() {
    return 'fa-adress-book';
  }
}

export class Bank extends Icon {
  getIcon() {
    return faDatabase;
  }
  getClassNames() {
    return 'icon-bank';
  }
}

export class FileLines extends Icon {
  getIcon() {
    return faFile;
  }

  getClassNames() {
    return 'fa-file-lines';
  }
}

export class Transmission extends Icon {
  getIcon() {
    return faCogs;
  }

  getClassNames() {
    return 'icon-transmission';
  }
}

export class Power extends Icon {
  getIcon() {
    return faBolt;
  }

  getClassNames() {
    return 'icon-power';
  }
}

export class FileDownload extends Icon {
  getIcon() {
    return faFileDownload;
  }

  getClassNames() {
    return 'icon-fileDownload';
  }
}

export class PlayCircle extends Icon {
  getIcon() {
    return faPlayCircle;
  }

  getClassNames() {
    return 'icon-play-circle';
  }
}

export class Deposit extends Icon {
  getIcon() {
    return faAngleDoubleDown;
  }

  getClassNames() {
    return 'icon-angle-double-down';
  }
}

export class Withdraw extends Icon {
  getIcon() {
    return faAngleDoubleUp;
  }

  getClassNames() {
    return 'icon-angle-double-up';
  }
}

export class Exchange extends Icon {
  getIcon() {
    return faExchangeAlt;
  }

  getClassNames() {
    return 'icon-exchange';
  }
}

export class BankAccount extends Icon {
  getIcon() {
    return faMoneyCheck;
  }

  getClassNames() {
    return 'icon-bank';
  }
}

export class Notification extends Icon {
  getIcon() {
    return faBell;
  }

  getClassNames() {
    return 'icon-notification';
  }
}

export class SortUp extends Icon {
  getIcon() {
    return faSortUp;
  }

  getClassNames() {
    return 'icon-sort-up';
  }
}

export class SortDown extends Icon {
  getIcon() {
    return faSortDown;
  }

  getClassNames() {
    return 'icon-sort-down';
  }
}

export class Chat extends Icon {
  getIcon() {
    return faComments;
  }

  getClassNames() {
    return 'icon-chat';
  }
}
export class Edit extends Icon {
  getIcon() {
    return faPencilAlt;
  }

  getClassNames() {
    return 'icon-edit';
  }
}

export class EditSquare extends Icon {
  getIcon() {
    return faPenSquare;
  }

  getClassNames() {
    return 'icon-edit-square';
  }
}

export class TimesSquare extends Icon {
  getIcon() {
    return faTimes;
  }

  getClassNames() {
    return 'fa-duotone fa-square-xmark';
  }
}

export class Reset extends Icon {
  getIcon() {
    return faSync;
  }

  getClassNames() {
    return 'icon-reset';
  }
}

export class AdminAction extends Icon {
  getIcon() {
    return faHammer;
  }

  getClassNames() {
    return 'icon-adminaction';
  }
}

export class View extends Icon {
  getIcon() {
    return faEye;
  }

  getClassNames() {
    return 'icon-view';
  }
}

export class Scale extends Icon {
  getIcon() {
    return faBalanceScaleRight;
  }

  getClassNames() {
    return 'icon-scale';
  }
}

export class Inspection extends Icon {
  getIcon() {
    return faClipboard;
  }

  getClassNames() {
    return 'icon-inspection';
  }
}

export class TitleMore extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ChevronRightIcon;
  }

  getClassNames() {
    return 'icon-title-more';
  }
}

export class Waiting extends Icon {
  getIcon() {
    return faHourglass;
  }

  getClassNames() {
    return 'icon-waiting';
  }
}

export class ArrowUp extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ArrowUpIcon;
  }

  getClassNames() {
    return 'icon-up';
  }
}

export class ArrowDown extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ArrowDownIcon;
  }

  getClassNames() {
    return 'icon-down';
  }
}
export class ParentToSub extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return CornerDownRight;
  }

  getClassNames() {
    return 'icon-down';
  }
}

export class Settings extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return SettingsIcon;
  }

  getClassNames() {
    return 'icon-settings';
  }
}

export class ChevronRight extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ChevronRightIcon;
  }

  getClassNames() {
    return 'icon-right';
  }
}

export class ChevronLeft extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ChevronLeftIcon;
  }

  getClassNames() {
    return 'icon-left';
  }
}

export class Document extends Icon {
  getIcon() {
    return faFileInvoice;
  }

  getClassNames() {
    return 'icon-document';
  }
}

export class Help extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return HelpCircle;
  }

  getClassNames() {
    return 'icon-help';
  }
}

export class Camera extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return CameraIcon;
  }

  getClassNames() {
    return 'fa-camera';
  }
}

export class Image extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return ImageIcon;
  }

  getClassNames() {
    return 'icon-image';
  }
}

export class PDF extends Icon {
  getIcon() {
    return faFilePdf;
  }

  getClassNames() {
    return 'icon-pdf';
  }
}

export class Copy extends Icon {
  getIcon() {
    return faClone;
  }

  getClassNames() {
    return 'icon-clone';
  }
}

export class Smile extends Icon {
  getIcon() {
    return faSmile;
  }

  getClassNames() {
    return 'icon-smile';
  }
}

export class Sync extends Icon {
  getIcon() {
    return faSyncAlt;
  }

  getClassNames() {
    return 'icon-sync';
  }
}

export class Taxation extends Icon {
  getIcon() {
    return faFileInvoiceDollar;
  }

  getClassNames() {
    return 'icon-taxation';
  }
}

export class Task extends Icon {
  getIcon() {
    return faThumbtack;
  }

  getClassNames() {
    return 'icon-task';
  }
}

export class Company extends Icon {
  getIcon() {
    return faBuilding;
  }

  getClassNames() {
    return 'icon-task';
  }
}

export class Trash extends Icon {
  getIcon() {
    return faTrash;
  }

  getClassNames() {
    return 'fa-sharp fa-solid fa-trash';
  }
}

export class Xmark extends Icon {
  getIcon() {
    return faTimes;
  }

  getClassNames() {
    return 'fa-sharp fa-solid fa-xmark';
  }
}

export class Stats extends Icon {
  getIcon() {
    return faChartLine;
  }

  getClassNames() {
    return 'icon-stats';
  }
}

export class User extends Icon {
  getIcon() {
    return faUser;
  }

  getClassNames() {
    return 'icon-user';
  }
}

export class Tools extends Icon {
  getIcon() {
    return faScrewdriver;
  }

  getClassNames() {
    return 'icon-tools';
  }
}

export class Upload extends Icon {
  getIcon() {
    return faCloudUploadAlt;
  }

  getClassNames() {
    return 'icon-upload';
  }
}

export function Columns(props) {
  return (
    <svg viewBox="0 0 18 16" width={props.size || '24'} height={props.size || '24'} className="icon">
      <rect x="1" y="1" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />
      <rect x="1" y="5" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />
      <rect x="1" y="9" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />
      <rect x="1" y="13" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />

      <rect x="10" y="1" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />
      <rect x="10" y="5" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />
      <rect x="10" y="9" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />
      <rect x="10" y="13" rx="1" ry="1" width="7" height="2" style={{ fill: props.fill || 'black' }} />
    </svg>
  );
}

export class BookOpen extends Icon {
  getIcon() {
    return faBookOpen;
  }

  getClassNames() {
    return 'icon-book-open';
  }
}

export class Circle extends Icon {
  getIcon() {
    return faCircle;
  }

  getClassNames() {
    return 'icon-circle';
  }
}

export class Hexon extends Icon {
  getProvider() {
    return TYPE_FEATHER;
  }

  getIcon() {
    return Bookmark;
  }

  getClassNames() {
    return 'icon-hexon';
  }
}

// export class ArrowUp extends Icon {
//   getIcon() {
//     return faArrowUp;
//   }
//
//   getClassNames() {
//     return 'icon-arrow-up';
//   }
// }
//
// export class ArrowDown extends Icon {
//   getIcon() {
//     return faArrowDown;
//   }
//
//   getClassNames() {
//     return 'icon-arrow-down';
//   }
// }

export class Sort extends Icon {
  getIcon() {
    return faSort;
  }

  getClassNames() {
    return 'icon-sort';
  }
}
